import styled from '@emotion/native';
import React, { FC } from 'react';

import {
  Row, Spacer
} from '@components/1-atoms/Miscellaneous';
import Text, { Props as TextProps } from '@components/1-atoms/Text';

export const Container = styled.TouchableOpacity`
  min-height: ${({ height }: any) => `${height || 58}px`};

  background-color: ${({ bg }: any) => bg || '#FFF'};
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 9px;

  width: ${({ theme }: any) => `${theme.contentWidth}px`};
  ${props => props?.inset && `
    width: ${props.theme.contentWidth - 30}px;
  `}

  border-bottom-width: 1.5px;
  border-bottom-color: #0000001c;
  border-bottom-style: ${({ hideLine }: any) => hideLine ? 'none' : 'solid'};

  margin-bottom: 3px;
`;

export const Content = styled.View`
  // width: calc(72.5% - 0px);
  width: 72.5%;
  flex-direction: column;
  // border-bottom: 1.5px rgb(0 0 0 / 11%) solid;
`;

export const Right = styled.View`
  // flex-grow: 3;
  // width: calc(27.5% - 0px);
  width: 27.5%;
  flex-direction: column;
  text-align: center;
  align-items: flex-end;
`;

export interface ListItemData {
  id: string;
  uuid: string;
  name: string;
  description?: string;
  value: Object | number | string | any;

  /* displayedText: string;
  subText?: string; */
}

export type Item = {
  onPress?: (item: ListItemData) => void;
  children?: React.ReactNode | string;
  inset?: boolean;
  bg?: string;
  sub?: React.ReactNode | string;
  right?: React.ReactNode | string;
  subright?: React.ReactNode | string;
  style?: object;
  height?: number;
  hideLine?: boolean;
}

export type Props = TextProps & Item;;

const ListItem: FC<Props> = ({ onPress, children, sub, right, subright, style, ...props }) => {
  return (
    <Container onPress={onPress} style={style} {...props}>

      <Content>
        <Text {...props}>{children}</Text>
        <Spacer h={0.3} />
        {sub && <Text ellipsis xsmall>{sub}</Text>}
      </Content>

      <Right>
        {right}
        {subright && <Text align='right' xsmall>{subright}</Text>}
      </Right>
    </Container>
  );
}

const Header = styled(Row)`
    text-transform: uppercase;
    background-color: ${({ theme }: any) => `#4d72a5`};
    padding: 6px 6px;
`;

type SectionHeaderProps = TextProps & { onPress?: () => void; }

// @ts-ignore
export const ListSectionHeader: FC<Props> = ({ children, ...props }) => <Header {...props}><Text xsmall bold color='white' {...props}>{children}</Text></Header>;

export default ListItem;
